import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding-top: 80px;
`;

const HeroSection = styled.div`
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
              url('/images/services-hero.jpg') center/cover no-repeat;
  padding: 100px 2rem;
  color: white;
  text-align: center;
`;

const MainHeading = styled.h1`
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-family: 'Playfair Display', serif;
  margin-bottom: 1.5rem;
`;

const Section = styled.section`
  padding: 5rem 2rem;
  background-color: ${props => props.background || 'white'};
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 2rem 0;
`;

const ServiceCard = styled.div`
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
  }
`;

const ServiceIcon = styled.div`
  background-color: #4CAF50;
  color: white;
  padding: 2rem;
  text-align: center;
  font-size: 2rem;
`;

const ServiceContent = styled.div`
  padding: 2rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const ServiceTitle = styled.h2`
  font-family: 'Playfair Display', serif;
  color: #333;
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

const ServiceDescription = styled.p`
  color: #666;
  line-height: 1.6;
`;

const ServicesPage = () => {
  const services = [
    {
      title: "GSM Installation and Commissioning",
      description: "We deliver complete installation and comissining services for GSM communication systems, ensuring robust, reliable, and high quality network connectivity essential for modern communication needs. Our comprehensive service includes network planning and design, equipment installation, system testing and optimization, backed by 24/7 support and maintenance.",
      icon: "📡"
    },
    {
      title: "Power Systems Engineering",
      description: "Our team specializes in designing and implementing hybrid and solar power solutions meticulously tailored to the unique requirements of our clients. We deliver automatic power systems known for their exceptional reliability and energy efficiency, incorporating custom system design, hybrid power solutions, and automated control systems.",
      icon: "⚡"
    },
    {
      title: "Information Technology (IT) Infrastructure",
      description: "We provide comprehensive services in developing and managing secure IT networks, including local area networks (LAN), wide area networks (WAN), and server systems. Our solutions encompass network architecture design, security implementation, server management, and cloud solutions, all designed to significantly enhance operational efficiency for our clients.",
      icon: "💻"
    },
    {
      title: "Civil Engineering Services",
      description: "We offer thorough site surveys, construction project management, and high-quality building and infrastructure projects that adhere to industry standards. Our expertise includes detailed site analysis, comprehensive project management, rigorous quality control measures, and sustainable development practices, ensuring safe and sustainable development for all projects.",
      icon: "🏗️"
    },
    {
      title: "Power Maintenance",
      description: "Our services include preventive and corrective maintenance, ensuring uninterrupted functionality of power systems, along with round-the-clock technical support for critical infrastructures. We provide comprehensive system monitoring, emergency repairs, and performance optimization to ensure optimal performance at all times.",
      icon: "🔧"
    },
    {
      title: "Solar Installation",
      description: "We provide comprehensive solar energy solutions, from initial assessment to installation and maintenance. Our expert team designs and implements solar power systems that maximize energy production while minimizing costs. Our services include detailed site assessment, high-efficiency solar panel installation, battery storage solutions, grid connection and net metering setup, advanced performance monitoring systems, and ongoing maintenance support to ensure optimal system performance.",
      icon: "☀️"
    }
  ];

  return (
    <PageContainer>
      <HeroSection>
        <MainHeading>Our Services</MainHeading>
        <p>Delivering Excellence in Engineering and Technology Solutions</p>
      </HeroSection>
      
      <Section>
        <Container>
          <ServicesGrid>
            {services.map((service, index) => (
              <ServiceCard key={index}>
                <ServiceIcon>{service.icon}</ServiceIcon>
                <ServiceContent>
                  <ServiceTitle>{service.title}</ServiceTitle>
                  <ServiceDescription>{service.description}</ServiceDescription>
                </ServiceContent>
              </ServiceCard>
            ))}
          </ServicesGrid>
        </Container>
      </Section>
    </PageContainer>
  );
};

export default ServicesPage;
